document.addEventListener('DOMContentLoaded', function(){
  changeHeaderThemeOnMobileMenuOpen();
  overrideMulticolumnDesktopSlider();
  initProductGridOnArticle();
  initRecentlyViewedProducts();
  initCollectionEventHandlers();
  initIsotopeReviewsMasonry();
});

function changeHeaderThemeOnMobileMenuOpen() {
  const menuBurger = document.querySelector("header-drawer .header__icon--summary");
  const header = document.querySelector("#header-component");
  const closeBtn = document.querySelector("header-drawer .menu-drawer__close-button");
  const isTransparent = header?.getAttribute("transparent");
  if (window.innerWidth >= 750 || !menuBurger || !header || !closeBtn || !isTransparent) return;

  header.style.position = 'absolute';
  header.style.top = 0;
  header.style.left = 0;
  header.style.right = 0;
  header.style.backgroundColor = 'transparent';
  header.style.zIndex = 'var(--layer-overlay)';

  menuBurger.addEventListener("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if(isTransparent) {
      if(header.getAttribute("transparent")) {
        header.removeAttribute("transparent");
      } else {
        header.setAttribute("transparent", "not-sticky");
      }
    }

    if(document.querySelector("header-drawer .menu-drawer-container").classList.contains("menu-open")) {
      document.querySelector("header-drawer .menu-drawer-container").removeAttribute("open");
      document.querySelector("header-drawer .menu-drawer-container").classList.remove("menu-open");
    } else {
      document.querySelector("header-drawer .menu-drawer-container").setAttribute("open", "open");
      document.querySelector("header-drawer .menu-drawer-container").classList.add("menu-open");
    }
  });
}

function overrideMulticolumnDesktopSlider() {
  const sliders = document.querySelectorAll('.craft-with-intention .section-content-wrapper > .group-block:last-child');
  if (sliders.length == 0) {
    // Try again later if theme scripts load asynchronously
    setTimeout(overrideMulticolumnDesktopSlider, 300);
    return;
  }
  sliders.forEach(slider => {
    if (window.innerWidth < 1024) return;

    const selector = slider.getAttribute('selector') || ':scope > .group-block-content > .group-block';
    const DRAG_THRESHOLD = 1; // px before we consider it a drag

    let pointerDown = false;
    let isDragging = false;
    let pointerId = null;
    let startX = 0;
    let initialScroll = 0;

    function enableNoSelect() { document.body.style.userSelect = 'none'; }
    function disableNoSelect() { document.body.style.userSelect = ''; }

    // Click suppression after a drag (one-time)
    function suppressNextClickOnce() {
      const onClick = (e) => {
        e.stopImmediatePropagation();
        e.preventDefault();
        slider.removeEventListener('click', onClick, true);
      };
      slider.addEventListener('click', onClick, { capture: true, once: true });
    }

    // Pointer events (preferred)
    if ('PointerEvent' in window) {
      slider.addEventListener('pointerdown', (e) => {
        // Only left button
        if (e.button && e.button !== 0) return;
        pointerDown = true;
        isDragging = false;
        pointerId = e.pointerId;
        startX = e.clientX;
        initialScroll = slider.scrollLeft;

        try { slider.setPointerCapture && slider.setPointerCapture(pointerId); } catch (err) {}
      });

      window.addEventListener('pointermove', (e) => {
        if (!pointerDown || e.pointerId !== pointerId) return;

        const dx = e.clientX - startX;

        if (!isDragging && Math.abs(dx) > DRAG_THRESHOLD) {
          isDragging = true;
          slider.classList.add('is-dragging');
          enableNoSelect();
        }

        if (isDragging) {
          e.preventDefault(); // avoid selection / native behaviour
          slider.scrollLeft = initialScroll - dx;
        }
      }, { passive: false });

      function pointerEndHandler(e) {
        if (!pointerDown || (e && e.pointerId !== pointerId)) return;
        pointerDown = false;

        const dx = e.clientX - startX;
        const threshold = 80; // pixels needed to trigger swipe
        const selector = slider.getAttribute('selector') || ':scope > .group-block-content > .group-block';
        const firstSlide = slider.querySelector(selector);

        // Safely get one slide width (including margin)
        let slideWidth = 0;
        if (firstSlide) {
          const styles = getComputedStyle(firstSlide);
          const marginRight = parseFloat(styles.marginRight) || 0;
          slideWidth = firstSlide.offsetWidth + marginRight;
        }

        // Determine direction & apply movement
        if (Math.abs(dx) > threshold && slideWidth > 0) {
          if (dx < -800) {
            // Swipe right → previous slide
            slider.scrollLeft += slideWidth;
          } else {
            // Swipe left → next slide
            slider.scrollLeft -= slideWidth;
          }
        } else {
          // Not enough movement → reset to where it started
          slider.scrollLeft = initialScroll;
        }

        isDragging = false;
        pointerId = null;
        slider.classList.remove('is-dragging');
        disableNoSelect();
      }

      window.addEventListener('pointerup', pointerEndHandler);
      window.addEventListener('pointercancel', pointerEndHandler);
    } else {
      // Fallback to mouse events (older browsers)
      let mouseDown = false;
      slider.addEventListener('mousedown', (e) => {
        if (e.button && e.button !== 0) return;
        mouseDown = true;
        pointerDown = true;
        isDragging = false;
        startX = e.clientX;
        initialScroll = slider.scrollLeft;
      });

      window.addEventListener('mousemove', (e) => {
        if (!mouseDown) return;
        const dx = e.clientX - startX;

        if (!isDragging && Math.abs(dx) > DRAG_THRESHOLD) {
          isDragging = true;
          slider.classList.add('is-dragging');
          enableNoSelect();
        }

        if (isDragging) {
          e.preventDefault();
          slider.scrollLeft = initialScroll - dx;
        }
      }, { passive: false });

      window.addEventListener('mouseup', (e) => {
        if (!mouseDown) return;
        mouseDown = false;
        pointerDown = false;

        if (isDragging) suppressNextClickOnce();

        isDragging = false;
        slider.classList.remove('is-dragging');
        disableNoSelect();
      });
    }

    // ✅ Start scrolled to the center of the entire slider
    requestAnimationFrame(() => {
      const totalScrollable = slider.scrollWidth - slider.clientWidth;
      if (totalScrollable > 0) {
        slider.scrollLeft = totalScrollable / 2;
      }
    });
  });
}

function initRecentlyViewedProducts() {
  const recentProductsKey = "recently_viewed_products";
  function saveRecentlyViewed(productHandle) {
    let products = JSON.parse(localStorage.getItem(recentProductsKey)) || [];
    products = products.filter(p => p !== productHandle); // duplicate remove
    products.unshift(productHandle); // new first
    if (products.length > 4) products.pop(); // max 4
    localStorage.setItem(recentProductsKey, JSON.stringify(products));
  }

  if(document.querySelector("body").classList.contains("template-product")) {
    const productHandle = "" + window.location.pathname.split("/products/")[1].split("/")[0];
    saveRecentlyViewed(productHandle);
  }

  const container = document.querySelector(".recently-viewed-section");
  if(!container) return;

  if (typeof window.jQuery === "undefined") {
    var script = document.createElement("script");
    script.src = "https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js";
    script.onload = function () {
      renderRecentlyViewed(jQuery);
    };
    document.head.appendChild(script);
  } else {
    renderRecentlyViewed(jQuery);
  }

  function renderRecentlyViewed($) {
    const productsHandles = JSON.parse(localStorage.getItem(recentProductsKey)) || [];
    if(productsHandles.length == 0) container.remove();

    const sectionId = $(container).attr("id").replace("shopify-section-", "");
    $(container).find(".resource-list.hidden--desktop > div > slideshow-component > slideshow-container > slideshow-slides > slideshow-slide").remove();

    const hideBrowseAllButton = productsHandles.length < 5 || false;
    if(hideBrowseAllButton) $(container).find(".section-resource-list > .section-resource-list__content > .link").remove();

    productsHandles.forEach((handle, index) => {
        fetch(`/products/${handle}.js`)
          .then((response) => {
            if (!response.ok) return;
            return response.json();
          })
          .then((product) => {
            const localCountry = Shopify.locale + '-' + Shopify.country;

            const price = (product.price / 100).toLocaleString(localCountry, {
              style: "currency",
              currency: Shopify.currency.active,
              currencyDisplay: "symbol",
            });

            const comparePrice = product.compare_at_price && product.compare_at_price > product.price
              ? (product.compare_at_price / 100).toLocaleString(localCountry, {
                  style: "currency",
                  currency: Shopify.currency.active,
                  currencyDisplay: "symbol",
                })
            : '';

            const productFeaturedImage = product.featured_image.replace("//cdn.shopify.com/s/files/1/0742/7938/7333", `${window.origin}/cdn/shop`);

            let productHtml = $(
              `<div class="resource-list__item">
                <style data-shopify=""></style>
                <product-card-link data-product-id="${product.id}" data-featured-media-url="${productFeaturedImage}" data-product-transition="true">
                  <product-card class="product-card" data-product-id="${product.id}" data-product-variants-size="${product.variants.length}" id="product-card-${product.id}-${index}__static-product-card" data-product-transition="true">
                    <a id="${product.id}-${index}" href="${product.url}" class="product-card__link" ref="productCardLink">
                      <span class="visually-hidden">
                        ${product.title}
                      </span>
                    </a>
                    <div class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;  --flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap; --horizontal-alignment: ; --vertical-alignment: ; --vertical-alignment-mobile: ; --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --product-card-gap: 8px; --quick-add-display: flex; --quick-add-mobile-display: flex;">
                      <div id="cardGallery" class="card-gallery card-gallery-${product.id}-${index}__product_card_gallery_${index} spacing-style border-style" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px; --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px; --padding-inline-end: 0px;" data-product-id="${product.id}" on:pointerenter="/previewImage" on:pointerleave="/resetImage" data-view-transition-to-main-product data-image-ratio="adapt">
                        <a class="contents" ref="cardGalleryLink" href="${product.url}" aria-label="${product.title}">
                          <slideshow-component ref="slideshow" style="--slideshow-timeline: --slide-1;" initial-slide="0" infinite data-generic-media-size="1">
                            <slideshow-container ref="slideshowContainer">
                              <slideshow-slides tabindex="-1" ref="scroller">
                                <slideshow-slide ref="slides[]" aria-hidden="false" style="view-timeline-name: --slide-1; --product-media-fit: cover;" class="product-media-container media-fit product-media-container--image" slide-id="${product.id}-${index}">
                                  <div class="product-media" data-media-id="${product.id}-${index}">
                                    <img src="${productFeaturedImage}&amp;width=3840" alt="${product.title}" srcset="${productFeaturedImage}&amp;width=240 240w, ${productFeaturedImage}&amp;width=352 352w, ${productFeaturedImage}&amp;width=832 832w, ${productFeaturedImage}&amp;width=1200 1200w, ${productFeaturedImage}&amp;width=1600 1600w, ${productFeaturedImage}&amp;width=1920 1920w, ${productFeaturedImage}&amp;width=2560 2560w, ${productFeaturedImage}&amp;width=3840 3840w" width="3840" height="6432" loading="lazy" sizes="auto, (min-width: 750px) 25.0vw, 100vw" class="product-media__image" transitiontoproduct="true" data_max_resolution="${productFeaturedImage}&amp;width=3840" fetchpriority="auto" style="--focal-point: 50.0% 50.0%; aspect-ratio: 19/32;">
                                  </div>
                                </slideshow-slide>
                              </slideshow-slides>
                            </slideshow-container>
                          </slideshow-component>
                        </a>
                        ${comparePrice != '' ? `
                          <div class="product-badges product-badges--top-right" style=" --badge-border-radius: 0px; --badge-font-family: var(--font-body--family); --badge-font-weight: var(--font-body--weight); --badge-text-transform: uppercase;">
                            <div class="product-badges__badge product-badges__badge--rectangle color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a">
                              Sale ${Math.round(((product.compare_at_price - product.price) * 100.0) / product.compare_at_price)}%
                            </div>
                          </div>` 
                          : ""
                        }
                        <quick-add-component class="quick-add color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a" ref="quickAdd" data-product-title="${product.title}">
                          <product-form-component data-sectionid="${sectionId}" data-product-id="" on:submit="/handleSubmit" class="quick-add__product-form-component quick-add__product-form-component--single-option quick-add__product-form-component--multi-variant">
                            <div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>
                            <form method="post" action="/cart/add" id="QuickAdd-ProductForm-${product.id}-${product.id}-${index}__product_card_gallery_${index}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                              <input type="hidden" name="form_type" value="product">
                              <input type="hidden" name="utf8" value="✓">
                              <input type="hidden" name="id" ref="variantId" value="${product.variants[0].id}">
                              <input type="hidden" name="quantity" value="1">
                              <add-to-cart-component ref="addToCartButtonContainer" data-product-variant-media="${productFeaturedImage}&amp;width=100" data-add-to-cart-animation="true">
                                <button id="" type="submit" name="add" ref="addToCartButton" on:click="/handleClick" class="button button quick-add__button quick-add__button--add">
                                  <span class="add-to-cart-text">
                                    <span class="svg-wrapper add-to-cart-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"></path>
                                      </svg>
                                    </span>
                                    <span class="add-to-cart-text__content is-visually-hidden-mobile">Add</span>
                                  </span>
                                  <span aria-hidden="true" class="add-to-cart-text--added">
                                    <span class="svg-wrapper add-to-cart-icon--added">
                                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark">
                                        <path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>
                                    </span>
                                    <span class="is-visually-hidden-mobile">Added</span>
                                  </span>
                                </button>
                              </add-to-cart-component>
                              <button class="button quick-add__button quick-add__button--choose" type="button" name="add" on:click="quick-add-component/handleClick">
                                <span class="add-to-cart-text">
                                  <span class="svg-wrapper add-to-cart-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <path d="M15.9136 4.65182C15.8773 4.60068 15.8313 4.55944 15.779 4.53111C15.7268 4.50279 15.6696 4.4881 15.6117 4.48813H12.5077L9.33858 0.159247C9.27274 0.0693326 9.17815 0.0128059 9.07562 0.00210172C8.97309 -0.00860251 8.87102 0.0273925 8.79186 0.102169C8.71269 0.176945 8.66292 0.284376 8.6535 0.40083C8.64408 0.517284 8.67577 0.63322 8.7416 0.723134L11.4979 4.48813H5.0409L7.36257 0.692979C7.42136 0.596895 7.44414 0.47822 7.4259 0.363059C7.40766 0.247898 7.34988 0.145685 7.26529 0.0789064C7.18069 0.0121279 7.0762 -0.0137465 6.97481 0.0069753C6.87342 0.0276971 6.78343 0.0933179 6.72463 0.189402L4.0949 4.48813H0.388511C0.329114 4.48812 0.270506 4.50358 0.217194 4.53332C0.163881 4.56307 0.117283 4.6063 0.0809838 4.6597C0.0446841 4.7131 0.0196491 4.77524 0.0078035 4.84135C-0.00404212 4.90746 -0.00238296 4.97577 0.0126537 5.04103L2.46654 15.6707C2.48836 15.765 2.53708 15.8485 2.60507 15.9081C2.67307 15.9676 2.75652 16 2.8424 16H13.6153C13.7042 16 13.7904 15.9653 13.8595 15.9018C13.9286 15.8382 13.9764 15.7496 13.9949 15.6509L15.9914 5.02122C16.0035 4.95696 16.0028 4.89043 15.9894 4.82651C15.9759 4.7626 15.95 4.70291 15.9136 4.65182ZM13.3008 15.1178H3.14203L0.891806 5.37036H15.1319L13.3008 15.1178Z" fill="currentColor"/>
                                    </svg>
                                  </span>
                                  <span class="add-to-cart-text__content is-visually-hidden-mobile">
                                    Add
                                  </span>
                                </span>
                              </button>
                              <input type="hidden" name="product-id" value="${product.id}">
                              <input type="hidden" name="section-id" value="${sectionId}">
                            </form>
                          </product-form-component>
                        </quick-add-component>
                      </div>
                      <div class=" group-block group-block--height-fit group-block--width-fill border-style spacing-style size-style" style=" --border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;  --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --size-style-width: 100%;--size-style-height: fit;--size-style-width-mobile: 100%; --size-style-width-mobile-min: 5rem;">
                        <div class="group-block__media-wrapper"> </div>
                        <div class=" group-block-content layout-panel-flex layout-panel-flex--column mobile-column" style="--flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap; --gap: 4px; --horizontal-alignment: center; --vertical-alignment: center; --vertical-alignment-mobile: center;">
                          <a class="contents user-select-text" ref="productTitleLink" href="${product.url}">
                            <div class=" spacing-style text-block text-block--${product.id}-${index}__product_title_${index} rte text-block--align-center text-block--full-width  rte" style="--padding-block-start: 0px; --padding-block-end:0px; --padding-inline-start:0px; --padding-inline-end:0px; --width: 100%;--max-width: var(--max-width--body-none);--text-align: center;">
                              <p>${product.title}</p>
                            </div>
                          </a>
                          <product-price class="text-block  text-center paragraph spacing-style" data-block-id="${product.id}-${index}__price_aYTqUN" data-product-id="${product.id}" style="--color: var(--color-foreground); --padding-block-start: 0px; --padding-block-end: 0px; --padding-inline-start: 0px; --padding-inline-end: 0px; --width: fit-content;">
                            <div ref="priceContainer">
                              <span role="group">
                                <span class="visually-hidden">Sale price&nbsp;</span>
                                <span class="price">${price}</span>
                              </span>
                              ${comparePrice != '' ? `
                                <span role="group">
                                  <span class="visually-hidden">Regular price&nbsp;</span>
                                  <span class="compare-at-price">${comparePrice}</span>
                                </span>` 
                                : ""
                              }
                            </div>
                          </product-price>
                        </div>
                      </div>
                    </div>
                  </product-card>
                </product-card-link>
              </div>
            `);

            let productSlide = $(`
              <slideshow-slide ref="slides[]" aria-hidden="false" style="view-timeline-name: --slide-${index}; --product-media-fit: cover;" class="resource-list__slide">
                <div class="resource-list__item">
                  <style data-shopify=""></style>
                  <product-card-link data-product-id="${product.id}" data-featured-media-url="${productFeaturedImage}" data-product-transition="true">
                    <product-card class="product-card" data-product-id="${product.id}" data-product-variants-size="${productFeaturedImage}" id="product-card-${product.id}-${index}__static-product-card" data-product-transition="true">
                      <a id="${product.id}-${index}" href="${product.url}" class="product-card__link" ref="productCardLink">
                        <span class="visually-hidden">
                          ${product.title}
                        </span>
                      </a>
                      <div class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;  --flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap; --horizontal-alignment: ; --vertical-alignment: ; --vertical-alignment-mobile: ; --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --product-card-gap: 4px; --quick-add-display: flex; --quick-add-mobile-display: flex;">
                        <div id="cardGallery" class="card-gallery card-gallery-${product.id}-${index}__product_card_gallery_${index} spacing-style border-style" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px; --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px; --padding-inline-end: 0px;" data-product-id="${product.id}" on:pointerenter="/previewImage" on:pointerleave="/resetImage" data-view-transition-to-main-product data-image-ratio="adapt">
                          <a class="contents" ref="cardGalleryLink" href="${product.url}" aria-label="${product.title}">
                            <slideshow-component ref="slideshow" style="--slideshow-timeline: --slide-1;" initial-slide="0" infinite data-generic-media-size="1">
                              <slideshow-container ref="slideshowContainer">
                                <slideshow-slides tabindex="-1" ref="scroller">
                                  <slideshow-slide ref="slides[]" aria-hidden="false" style="view-timeline-name: --slide-1; --product-media-fit: cover;" class="product-media-container media-fit product-media-container--image" slide-id="${product.id}-${index}">
                                    <div class="product-media" data-media-id="${product.id}-${index}">
                                      <img src="${productFeaturedImage}&amp;width=3840" alt="${product.title}" srcset="${productFeaturedImage}&amp;width=240 240w, ${productFeaturedImage}&amp;width=352 352w, ${productFeaturedImage}&amp;width=832 832w, ${productFeaturedImage}&amp;width=1200 1200w, ${productFeaturedImage}&amp;width=1600 1600w, ${productFeaturedImage}&amp;width=1920 1920w, ${productFeaturedImage}&amp;width=2560 2560w, ${productFeaturedImage}&amp;width=3840 3840w" width="3840" height="6432" loading="lazy" sizes="auto, (min-width: 750px) 25.0vw, 100vw" class="product-media__image" transitiontoproduct="true" data_max_resolution="${productFeaturedImage}&amp;width=3840" fetchpriority="auto" style="--focal-point: 50.0% 50.0%; aspect-ratio: 19/32;">
                                    </div>
                                  </slideshow-slide>
                                </slideshow-slides>
                              </slideshow-container>
                            </slideshow-component>
                          </a>
                          ${comparePrice != '' ? `
                            <div class="product-badges product-badges--top-right" style=" --badge-border-radius: 0px; --badge-font-family: var(--font-body--family); --badge-font-weight: var(--font-body--weight); --badge-text-transform: uppercase;">
                              <div class="product-badges__badge product-badges__badge--rectangle color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a">
                                Sale ${Math.round(((product.compare_at_price - product.price) * 100.0) / product.compare_at_price)}%
                              </div>
                            </div>` 
                            : ""
                          }
                          <quick-add-component class="quick-add color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a" ref="quickAdd" data-product-title="${product.title}">
                            <product-form-component data-sectionid="${sectionId}" data-product-id="" on:submit="/handleSubmit" class="quick-add__product-form-component quick-add__product-form-component--single-option quick-add__product-form-component--multi-variant">
                              <div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>
                              <form method="post" action="/cart/add" id="QuickAdd-ProductForm-${product.id}-${product.id}-${index}__product_card_gallery_${index}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                <input type="hidden" name="form_type" value="product">
                                <input type="hidden" name="utf8" value="✓">
                                <input type="hidden" name="id" ref="variantId" value="${product.variants[0].id}">
                                <input type="hidden" name="quantity" value="1">
                                <add-to-cart-component ref="addToCartButtonContainer" data-product-variant-media="${productFeaturedImage}&amp;width=100" data-add-to-cart-animation="true">
                                  <button id="" type="submit" name="add" ref="addToCartButton" on:click="/handleClick" class="button button quick-add__button quick-add__button--add">
                                    <span class="add-to-cart-text">
                                      <span class="svg-wrapper add-to-cart-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"></path>
                                        </svg>
                                      </span>
                                      <span class="add-to-cart-text__content is-visually-hidden-mobile">Add</span>
                                    </span>
                                    <span aria-hidden="true" class="add-to-cart-text--added">
                                      <span class="svg-wrapper add-to-cart-icon--added">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark">
                                          <path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                      </span>
                                      <span class="is-visually-hidden-mobile">Added</span>
                                    </span>
                                  </button>
                                </add-to-cart-component>
                                <button class="button quick-add__button quick-add__button--choose" type="button" name="add" on:click="quick-add-component/handleClick">
                                  <span class="add-to-cart-text">
                                    <span class="svg-wrapper add-to-cart-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M15.9136 4.65182C15.8773 4.60068 15.8313 4.55944 15.779 4.53111C15.7268 4.50279 15.6696 4.4881 15.6117 4.48813H12.5077L9.33858 0.159247C9.27274 0.0693326 9.17815 0.0128059 9.07562 0.00210172C8.97309 -0.00860251 8.87102 0.0273925 8.79186 0.102169C8.71269 0.176945 8.66292 0.284376 8.6535 0.40083C8.64408 0.517284 8.67577 0.63322 8.7416 0.723134L11.4979 4.48813H5.0409L7.36257 0.692979C7.42136 0.596895 7.44414 0.47822 7.4259 0.363059C7.40766 0.247898 7.34988 0.145685 7.26529 0.0789064C7.18069 0.0121279 7.0762 -0.0137465 6.97481 0.0069753C6.87342 0.0276971 6.78343 0.0933179 6.72463 0.189402L4.0949 4.48813H0.388511C0.329114 4.48812 0.270506 4.50358 0.217194 4.53332C0.163881 4.56307 0.117283 4.6063 0.0809838 4.6597C0.0446841 4.7131 0.0196491 4.77524 0.0078035 4.84135C-0.00404212 4.90746 -0.00238296 4.97577 0.0126537 5.04103L2.46654 15.6707C2.48836 15.765 2.53708 15.8485 2.60507 15.9081C2.67307 15.9676 2.75652 16 2.8424 16H13.6153C13.7042 16 13.7904 15.9653 13.8595 15.9018C13.9286 15.8382 13.9764 15.7496 13.9949 15.6509L15.9914 5.02122C16.0035 4.95696 16.0028 4.89043 15.9894 4.82651C15.9759 4.7626 15.95 4.70291 15.9136 4.65182ZM13.3008 15.1178H3.14203L0.891806 5.37036H15.1319L13.3008 15.1178Z" fill="currentColor"/>
                                      </svg>
                                    </span>
                                    <span class="add-to-cart-text__content is-visually-hidden-mobile">
                                      Add
                                    </span>
                                  </span>
                                </button>
                                <input type="hidden" name="product-id" value="${product.id}">
                                <input type="hidden" name="section-id" value="${sectionId}">
                              </form>
                            </product-form-component>
                          </quick-add-component>
                        </div>
                        <div class=" group-block group-block--height-fit group-block--width-fill border-style spacing-style size-style" style=" --border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;  --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --size-style-width: 100%;--size-style-height: fit;--size-style-width-mobile: 100%; --size-style-width-mobile-min: 5rem;">
                          <div class="group-block__media-wrapper"> </div>
                          <div class=" group-block-content layout-panel-flex layout-panel-flex--column mobile-column" style="--flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap; --gap: 4px; --horizontal-alignment: center; --vertical-alignment: center; --vertical-alignment-mobile: center;">
                            <a class="contents user-select-text" ref="productTitleLink" href="${product.url}">
                              <div class=" spacing-style text-block text-block--${product.id}-${index}__product_title_${index} rte text-block--align-center text-block--full-width  rte" style="--padding-block-start: 0px; --padding-block-end:0px; --padding-inline-start:0px; --padding-inline-end:0px; --width: 100%;--max-width: var(--max-width--body-none);--text-align: center;">
                                <p>${product.title}</p>
                              </div>
                            </a>
                            <product-price class="text-block  text-center paragraph spacing-style" data-block-id="${product.id}-${index}__price_aYTqUN" data-product-id="${product.id}" style="--color: var(--color-foreground); --padding-block-start: 0px; --padding-block-end: 0px; --padding-inline-start: 0px; --padding-inline-end: 0px; --width: fit-content;">
                              <div ref="priceContainer">
                                <span role="group">
                                  <span class="visually-hidden">Sale price&nbsp;</span>
                                  <span class="price">${price}</span>
                                </span>
                                ${comparePrice != '' ? `
                                  <span role="group">
                                    <span class="visually-hidden">Regular price&nbsp;</span>
                                    <span class="compare-at-price">${comparePrice}</span>
                                  </span>` 
                                  : ""
                                }
                              </div>
                            </product-price>
                          </div>
                        </div>
                      </div>
                    </product-card>
                  </product-card-link>
                </div>
              </slideshow-slide>
            `);

            $(container).find(".resource-list.hidden--mobile").append(productHtml);
            $(container).find(".resource-list.hidden--desktop > div > slideshow-component > slideshow-container > slideshow-slides").append(productSlide);
          });
      });
  }
}

function initProductGridOnArticle() {
  if(!document.querySelector("body").classList.contains("template-article")) return;

  if (typeof window.jQuery === "undefined") {
    var script = document.createElement("script");
    script.src = "https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js";
    script.onload = function () {
      runProductGridLogic(jQuery);
    };
    document.head.appendChild(script);
  } else {
    runProductGridLogic(jQuery);
  }

  function runProductGridLogic($) {
    const productGrids = $(".blog-post-content .article-product-grid");
    if (!productGrids) return;

    productGrids.each((index, grid) => {
      const gridProductHandles = JSON.parse($(grid).attr("data-products")) || [];
      console.log(gridProductHandles);
      let gridElement = $(`
        <div id="shopify-section-template--article__product_list_${index}" class="shopify-section ui-test-product-list">
          <div class="section-background color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a"></div>
          <div class="
            section
            section--page-width
            color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a
            section-resource-list
            spacing-style
            gap-style" style="
            --padding-block-start: 0;--padding-block-end: 0;
            --gap: max(24px, calc(var(--gap-scale, 1.0) * 28px));
            --full-page-grid-with-margins: 0 1fr;
          ">
            <div class="section-resource-list__header"></div>
            </div>
        </div>
      `);
      
      let desktopGrid = $(`
        <div class="resource-list hidden--mobile resource-list--grid" style="--resource-list-column-gap-desktop: 4px;--resource-list-row-gap-desktop: 24px;--resource-list-columns: repeat(2, 1fr);--resource-list-columns-mobile: repeat(2, 1fr);--column-count-mobile: 2;" data-testid="resource-list-grid"></div>
      `);

      let mobileGrid = $(`
        <div class="resource-list hidden--desktop resource-list__carousel force-full-width" style="--resource-list-column-gap-desktop: 4px; --column-count: 4;      --column-count-mobile: 1; --mobile-card-size: 60cqw;" data-testid="resource-list-grid">
          <div class="resource-list__carousel" style="--gutter-slide-width: var(--util-page-margin-offset); --slide-width-max: 450px;">
            <slideshow-component ref="resourceListCarouselMobile" class="resource-list__carousel" style="--slideshow-timeline: --slide-1, --slide-2, --slide-3, --slide-4, --slide-5, --slide-6, --slide-7, --slide-8;" initial-slide="0" initial-slide="0" paused actioned>
              <slideshow-container ref="slideshowContainer">
                <slideshow-arrows position="center">
                  <button class="slideshow-control slideshow-control--previous slideshow-control--style button button-unstyled button-unstyled--transparent flip-x" aria-label="Previous slide" on:click="/previous" ref="previous" disabled="">
                    <span class="svg-wrapper icon-arrow">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"></path>
                      </svg>
                    </span>
                  </button>
                  <button class="slideshow-control slideshow-control--next slideshow-control--style-arrow button button-unstyled button-unstyled--transparent" aria-label="Next slide" on:click="/next" ref="next">
                    <span class="svg-wrapper icon-arrow">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"></path>
                      </svg>
                    </span>
                  </button>
                </slideshow-arrows>
                <slideshow-slides tabindex="-1" ref="scroller" gutters="start end"></slideshow-slides>
              </slideshow-container>
            </slideshow-component>
          </div>
        </div>
      `);

      gridProductHandles.forEach((handle, pindex) => {
        fetch(`/products/${handle}.js`)
          .then((response) => {
            if (!response.ok) return;
            return response.json();
          })
          .then((product) => {
            const localCountry = Shopify.locale + '-' + Shopify.country;

            const price = (product.price / 100).toLocaleString(localCountry, {
              style: "currency",
              currency: Shopify.currency.active,
              currencyDisplay: "symbol",
            });

            const comparePrice =
              product.compare_at_price && product.compare_at_price > product.price
                ? (product.compare_at_price / 100).toLocaleString(localCountry, {
                    style: "currency",
                    currency: Shopify.currency.active,
                    currencyDisplay: "symbol",
                  })
                : '';

            const productFeaturedImage = product.featured_image.replace("//cdn.shopify.com/s/files/1/0742/7938/7333", `${window.origin}/cdn/shop`);

            let productHtml = $(
              `<div class="resource-list__item">
                <style data-shopify=""></style>
                <product-card-link data-product-id="" data-featured-media-url="${productFeaturedImage}" data-product-transition="true">
                  <product-card class="product-card" data-product-id="${product.id}" data-product-variants-size="${product.variants.length}" id="product-card-${product.id}-${index}__static-product-card" data-product-transition="true">
                    <a id="${product.id}-${index}" href="${product.url}" class="product-card__link" ref="productCardLink">
                      <span class="visually-hidden">
                        ${product.title}
                      </span>
                    </a>
                    <div class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;  --flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap; --horizontal-alignment: ; --vertical-alignment: ; --vertical-alignment-mobile: ; --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --product-card-gap: 4px; --quick-add-display: flex; --quick-add-mobile-display: flex;">
                      <div id="cardGallery" class="card-gallery card-gallery-${product.id}-${index}__product_card_gallery_${index} spacing-style border-style" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px; --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px; --padding-inline-end: 0px;" data-product-id="${product.id}" on:pointerenter="/previewImage" on:pointerleave="/resetImage" data-view-transition-to-main-product data-image-ratio="adapt">
                        <a class="contents" ref="cardGalleryLink" href="${product.url}" aria-label="${product.title}">
                          <slideshow-component ref="slideshow" style="--slideshow-timeline: --slide-1;" initial-slide="0" infinite data-generic-media-size="1">
                            <slideshow-container ref="slideshowContainer">
                              <slideshow-slides tabindex="-1" ref="scroller">
                                <slideshow-slide ref="slides[]" aria-hidden="false" style="view-timeline-name: --slide-1; --product-media-fit: cover;" class="product-media-container media-fit product-media-container--image" slide-id="${product.id}-${index}">
                                  <div class="product-media" data-media-id="${product.id}-${index}">
                                    <img src="${productFeaturedImage}&amp;width=3840" alt="${product.title}" srcset="${productFeaturedImage}&amp;width=240 240w, ${productFeaturedImage}&amp;width=352 352w, ${productFeaturedImage}&amp;width=832 832w, ${productFeaturedImage}&amp;width=1200 1200w, ${productFeaturedImage}&amp;width=1600 1600w, ${productFeaturedImage}&amp;width=1920 1920w, ${productFeaturedImage}&amp;width=2560 2560w, ${productFeaturedImage}&amp;width=3840 3840w" width="3840" height="6432" loading="lazy" sizes="auto, (min-width: 750px) 25.0vw, 100vw" class="product-media__image" transitiontoproduct="true" data_max_resolution="${productFeaturedImage}&amp;width=3840" fetchpriority="auto" style="--focal-point: 50.0% 50.0%; aspect-ratio: 19/32;">
                                  </div>
                                </slideshow-slide>
                              </slideshow-slides>
                            </slideshow-container>
                          </slideshow-component>
                        </a>
                        ${comparePrice != '' ? `
                          <div class="product-badges product-badges--top-right" style=" --badge-border-radius: 0px; --badge-font-family: var(--font-body--family); --badge-font-weight: var(--font-body--weight); --badge-text-transform: uppercase;">
                            <div class="product-badges__badge product-badges__badge--rectangle color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a">
                              Sale ${Math.round(((product.compare_at_price - product.price) * 100.0) / product.compare_at_price)}%
                            </div>
                          </div>` 
                          : ""
                        }
                        <quick-add-component class="quick-add color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a" ref="quickAdd" data-product-title="${product.title}">
                          <product-form-component data-sectionid="template--article__product_list_${index}" data-product-id="" on:submit="/handleSubmit" class="quick-add__product-form-component quick-add__product-form-component--single-option quick-add__product-form-component--multi-variant">
                            <div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>
                            <form method="post" action="/cart/add" id="QuickAdd-ProductForm-${product.id}-${product.id}-${index}__product_card_gallery_${index}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                              <input type="hidden" name="form_type" value="product">
                              <input type="hidden" name="utf8" value="✓">
                              <input type="hidden" name="id" ref="variantId" value="${product.variants[0].id}">
                              <input type="hidden" name="quantity" value="1">
                              <add-to-cart-component ref="addToCartButtonContainer" data-product-variant-media="${productFeaturedImage}&amp;width=100" data-add-to-cart-animation="true">
                                <button id="" type="submit" name="add" ref="addToCartButton" on:click="/handleClick" class="button button quick-add__button quick-add__button--add">
                                  <span class="add-to-cart-text">
                                    <span class="svg-wrapper add-to-cart-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"></path>
                                      </svg>
                                    </span>
                                    <span class="add-to-cart-text__content is-visually-hidden-mobile">Add</span>
                                  </span>
                                  <span aria-hidden="true" class="add-to-cart-text--added">
                                    <span class="svg-wrapper add-to-cart-icon--added">
                                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark">
                                        <path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>
                                    </span>
                                    <span class="is-visually-hidden-mobile">Added</span>
                                  </span>
                                </button>
                              </add-to-cart-component>
                              <button class="button quick-add__button quick-add__button--choose" type="button" name="add" on:click="quick-add-component/handleClick">
                                <span class="add-to-cart-text">
                                  <span class="svg-wrapper add-to-cart-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                      <path d="M15.9136 4.65182C15.8773 4.60068 15.8313 4.55944 15.779 4.53111C15.7268 4.50279 15.6696 4.4881 15.6117 4.48813H12.5077L9.33858 0.159247C9.27274 0.0693326 9.17815 0.0128059 9.07562 0.00210172C8.97309 -0.00860251 8.87102 0.0273925 8.79186 0.102169C8.71269 0.176945 8.66292 0.284376 8.6535 0.40083C8.64408 0.517284 8.67577 0.63322 8.7416 0.723134L11.4979 4.48813H5.0409L7.36257 0.692979C7.42136 0.596895 7.44414 0.47822 7.4259 0.363059C7.40766 0.247898 7.34988 0.145685 7.26529 0.0789064C7.18069 0.0121279 7.0762 -0.0137465 6.97481 0.0069753C6.87342 0.0276971 6.78343 0.0933179 6.72463 0.189402L4.0949 4.48813H0.388511C0.329114 4.48812 0.270506 4.50358 0.217194 4.53332C0.163881 4.56307 0.117283 4.6063 0.0809838 4.6597C0.0446841 4.7131 0.0196491 4.77524 0.0078035 4.84135C-0.00404212 4.90746 -0.00238296 4.97577 0.0126537 5.04103L2.46654 15.6707C2.48836 15.765 2.53708 15.8485 2.60507 15.9081C2.67307 15.9676 2.75652 16 2.8424 16H13.6153C13.7042 16 13.7904 15.9653 13.8595 15.9018C13.9286 15.8382 13.9764 15.7496 13.9949 15.6509L15.9914 5.02122C16.0035 4.95696 16.0028 4.89043 15.9894 4.82651C15.9759 4.7626 15.95 4.70291 15.9136 4.65182ZM13.3008 15.1178H3.14203L0.891806 5.37036H15.1319L13.3008 15.1178Z" fill="currentColor"/>
                                    </svg>
                                  </span>
                                  <span class="add-to-cart-text__content is-visually-hidden-mobile">
                                    Add
                                  </span>
                                </span>
                              </button>
                              <input type="hidden" name="product-id" value="${product.id}">
                              <input type="hidden" name="section-id" value="template--article__product_list_${index}">
                            </form>
                          </product-form-component>
                        </quick-add-component>
                      </div>
                      <div class=" group-block group-block--height-fit group-block--width-fill border-style spacing-style size-style" style=" --border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;  --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --size-style-width: 100%;--size-style-height: fit;--size-style-width-mobile: 100%; --size-style-width-mobile-min: 5rem;">
                        <div class="group-block__media-wrapper"> </div>
                        <div class=" group-block-content layout-panel-flex layout-panel-flex--column mobile-column" style="--flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap; --gap: 4px; --horizontal-alignment: center; --vertical-alignment: center; --vertical-alignment-mobile: center;">
                          <a class="contents user-select-text" ref="productTitleLink" href="${product.url}">
                            <div class=" spacing-style text-block text-block--${product.id}-${index}__product_title_${index} rte text-block--align-center text-block--full-width  rte" style="--padding-block-start: 0px; --padding-block-end:0px; --padding-inline-start:0px; --padding-inline-end:0px; --width: 100%;--max-width: var(--max-width--body-none);--text-align: center;">
                              <p>${product.title}</p>
                            </div>
                          </a>
                          <product-price class="text-block  text-center paragraph spacing-style" data-block-id="${product.id}-${index}__price_aYTqUN" data-product-id="${product.id}" style="--color: var(--color-foreground); --padding-block-start: 0px; --padding-block-end: 0px; --padding-inline-start: 0px; --padding-inline-end: 0px; --width: fit-content;">
                            <div ref="priceContainer">
                              <span role="group">
                                <span class="visually-hidden">Sale price&nbsp;</span>
                                <span class="price">${price}</span>
                              </span>
                              ${comparePrice != '' ? `
                                <span role="group">
                                  <span class="visually-hidden">Regular price&nbsp;</span>
                                  <span class="compare-at-price">${comparePrice}</span>
                                </span>` 
                                : ""
                              }
                            </div>
                          </product-price>
                        </div>
                      </div>
                    </div>
                  </product-card>
                </product-card-link>
              </div>
            `);

            let productSlide = $(`
              <slideshow-slide ref="slides[]" aria-hidden="false" style="view-timeline-name: --slide-${pindex}; --product-media-fit: cover;" class="resource-list__slide">
                <div class="resource-list__item">
                  <style data-shopify=""></style>
                  <product-card-link data-product-id="${product.id}" data-featured-media-url="${productFeaturedImage}" data-product-transition="true">
                    <product-card class="product-card" data-product-id="${product.id}" data-product-variants-size="${productFeaturedImage}" id="product-card-${product.id}-${index}__static-product-card" data-product-transition="true">
                      <a id="${product.id}-${index}" href="${product.url}" class="product-card__link" ref="productCardLink">
                        <span class="visually-hidden">
                          ${product.title}
                        </span>
                      </a>
                      <div class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;  --flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap; --horizontal-alignment: ; --vertical-alignment: ; --vertical-alignment-mobile: ; --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --product-card-gap: 4px; --quick-add-display: flex; --quick-add-mobile-display: flex;">
                        <div id="cardGallery" class="card-gallery card-gallery-${product.id}-${index}__product_card_gallery_${index} spacing-style border-style" style="--border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px; --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px; --padding-inline-end: 0px;" data-product-id="${product.id}" on:pointerenter="/previewImage" on:pointerleave="/resetImage" data-view-transition-to-main-product data-image-ratio="adapt">
                          <a class="contents" ref="cardGalleryLink" href="${product.url}" aria-label="${product.title}">
                            <slideshow-component ref="slideshow" style="--slideshow-timeline: --slide-1;" initial-slide="0" infinite data-generic-media-size="1">
                              <slideshow-container ref="slideshowContainer">
                                <slideshow-slides tabindex="-1" ref="scroller">
                                  <slideshow-slide ref="slides[]" aria-hidden="false" style="view-timeline-name: --slide-1; --product-media-fit: cover;" class="product-media-container media-fit product-media-container--image" slide-id="${product.id}-${index}">
                                    <div class="product-media" data-media-id="${product.id}-${index}">
                                      <img src="${productFeaturedImage}&amp;width=3840" alt="${product.title}" srcset="${productFeaturedImage}&amp;width=240 240w, ${productFeaturedImage}&amp;width=352 352w, ${productFeaturedImage}&amp;width=832 832w, ${productFeaturedImage}&amp;width=1200 1200w, ${productFeaturedImage}&amp;width=1600 1600w, ${productFeaturedImage}&amp;width=1920 1920w, ${productFeaturedImage}&amp;width=2560 2560w, ${productFeaturedImage}&amp;width=3840 3840w" width="3840" height="6432" loading="lazy" sizes="auto, (min-width: 750px) 25.0vw, 100vw" class="product-media__image" transitiontoproduct="true" data_max_resolution="${productFeaturedImage}&amp;width=3840" fetchpriority="auto" style="--focal-point: 50.0% 50.0%; aspect-ratio: 19/32;">
                                    </div>
                                  </slideshow-slide>
                                </slideshow-slides>
                              </slideshow-container>
                            </slideshow-component>
                          </a>
                          ${comparePrice != '' ? `
                            <div class="product-badges product-badges--top-right" style=" --badge-border-radius: 0px; --badge-font-family: var(--font-body--family); --badge-font-weight: var(--font-body--weight); --badge-text-transform: uppercase;">
                              <div class="product-badges__badge product-badges__badge--rectangle color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a">
                                Sale ${Math.round(((product.compare_at_price - product.price) * 100.0) / product.compare_at_price)}%
                              </div>
                            </div>` 
                            : ""
                          }
                          <quick-add-component class="quick-add color-scheme-5d282eea-1139-49b7-bbb5-7c56ddec5a4a" ref="quickAdd" data-product-title="${product.title}">
                            <product-form-component data-sectionid="template--article__product_list_${index}" data-product-id="" on:submit="/handleSubmit" class="quick-add__product-form-component quick-add__product-form-component--single-option quick-add__product-form-component--multi-variant">
                              <div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>
                              <form method="post" action="/cart/add" id="QuickAdd-ProductForm-${product.id}-${product.id}-${index}__product_card_gallery_${index}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                                <input type="hidden" name="form_type" value="product">
                                <input type="hidden" name="utf8" value="✓">
                                <input type="hidden" name="id" ref="variantId" value="${product.variants[0].id}">
                                <input type="hidden" name="quantity" value="1">
                                <add-to-cart-component ref="addToCartButtonContainer" data-product-variant-media="${productFeaturedImage}&amp;width=100" data-add-to-cart-animation="true">
                                  <button id="" type="submit" name="add" ref="addToCartButton" on:click="/handleClick" class="button button quick-add__button quick-add__button--add">
                                    <span class="add-to-cart-text">
                                      <span class="svg-wrapper add-to-cart-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"></path>
                                        </svg>
                                      </span>
                                      <span class="add-to-cart-text__content is-visually-hidden-mobile">Add</span>
                                    </span>
                                    <span aria-hidden="true" class="add-to-cart-text--added">
                                      <span class="svg-wrapper add-to-cart-icon--added">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark">
                                          <path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                      </span>
                                      <span class="is-visually-hidden-mobile">Added</span>
                                    </span>
                                  </button>
                                </add-to-cart-component>
                                <button class="button quick-add__button quick-add__button--choose" type="button" name="add" on:click="quick-add-component/handleClick">
                                  <span class="add-to-cart-text">
                                    <span class="svg-wrapper add-to-cart-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M15.9136 4.65182C15.8773 4.60068 15.8313 4.55944 15.779 4.53111C15.7268 4.50279 15.6696 4.4881 15.6117 4.48813H12.5077L9.33858 0.159247C9.27274 0.0693326 9.17815 0.0128059 9.07562 0.00210172C8.97309 -0.00860251 8.87102 0.0273925 8.79186 0.102169C8.71269 0.176945 8.66292 0.284376 8.6535 0.40083C8.64408 0.517284 8.67577 0.63322 8.7416 0.723134L11.4979 4.48813H5.0409L7.36257 0.692979C7.42136 0.596895 7.44414 0.47822 7.4259 0.363059C7.40766 0.247898 7.34988 0.145685 7.26529 0.0789064C7.18069 0.0121279 7.0762 -0.0137465 6.97481 0.0069753C6.87342 0.0276971 6.78343 0.0933179 6.72463 0.189402L4.0949 4.48813H0.388511C0.329114 4.48812 0.270506 4.50358 0.217194 4.53332C0.163881 4.56307 0.117283 4.6063 0.0809838 4.6597C0.0446841 4.7131 0.0196491 4.77524 0.0078035 4.84135C-0.00404212 4.90746 -0.00238296 4.97577 0.0126537 5.04103L2.46654 15.6707C2.48836 15.765 2.53708 15.8485 2.60507 15.9081C2.67307 15.9676 2.75652 16 2.8424 16H13.6153C13.7042 16 13.7904 15.9653 13.8595 15.9018C13.9286 15.8382 13.9764 15.7496 13.9949 15.6509L15.9914 5.02122C16.0035 4.95696 16.0028 4.89043 15.9894 4.82651C15.9759 4.7626 15.95 4.70291 15.9136 4.65182ZM13.3008 15.1178H3.14203L0.891806 5.37036H15.1319L13.3008 15.1178Z" fill="currentColor"/>
                                      </svg>
                                    </span>
                                    <span class="add-to-cart-text__content is-visually-hidden-mobile">
                                      Add
                                    </span>
                                  </span>
                                </button>
                                <input type="hidden" name="product-id" value="${product.id}">
                                <input type="hidden" name="section-id" value="template--article__product_list_${index}">
                              </form>
                            </product-form-component>
                          </quick-add-component>
                        </div>
                        <div class=" group-block group-block--height-fit group-block--width-fill border-style spacing-style size-style" style=" --border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;  --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --size-style-width: 100%;--size-style-height: fit;--size-style-width-mobile: 100%; --size-style-width-mobile-min: 5rem;">
                          <div class="group-block__media-wrapper"> </div>
                          <div class=" group-block-content layout-panel-flex layout-panel-flex--column mobile-column" style="--flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap; --gap: 4px; --horizontal-alignment: center; --vertical-alignment: center; --vertical-alignment-mobile: center;">
                            <a class="contents user-select-text" ref="productTitleLink" href="${product.url}">
                              <div class=" spacing-style text-block text-block--${product.id}-${index}__product_title_${index} rte text-block--align-center text-block--full-width  rte" style="--padding-block-start: 0px; --padding-block-end:0px; --padding-inline-start:0px; --padding-inline-end:0px; --width: 100%;--max-width: var(--max-width--body-none);--text-align: center;">
                                <p>${product.title}</p>
                              </div>
                            </a>
                            <product-price class="text-block  text-center paragraph spacing-style" data-block-id="${product.id}-${index}__price_aYTqUN" data-product-id="${product.id}" style="--color: var(--color-foreground); --padding-block-start: 0px; --padding-block-end: 0px; --padding-inline-start: 0px; --padding-inline-end: 0px; --width: fit-content;">
                              <div ref="priceContainer">
                                <span role="group">
                                  <span class="visually-hidden">Sale price&nbsp;</span>
                                  <span class="price">${price}</span>
                                </span>
                                ${comparePrice != '' ? `
                                  <span role="group">
                                    <span class="visually-hidden">Regular price&nbsp;</span>
                                    <span class="compare-at-price">${comparePrice}</span>
                                  </span>` 
                                  : ""
                                }
                              </div>
                            </product-price>
                          </div>
                        </div>
                      </div>
                    </product-card>
                  </product-card-link>
                </div>
              </slideshow-slide>
            `);

            $(desktopGrid).append(productHtml);
            $(mobileGrid).find("> div > slideshow-component > slideshow-container > slideshow-slides").append(productSlide);
          });
      });

      $(gridElement).find(".section-resource-list").append(desktopGrid);
      $(gridElement).find(".section-resource-list").append(mobileGrid);
      $(grid).append($(gridElement));
    });
  }
}

function initCollectionEventHandlers() {
  if(!document.querySelector("body").classList.contains("template-collection")) return;

  function enableStickyFilter(elem = '.facets--horizontal') {
    const sticky = document.querySelector(elem);
    if(!sticky) return;

    const headerHeight = parseInt(document.querySelector("body")?.style.getPropertyValue("--header-height").replace("px", "")) - 5;
    const stickyTop = sticky.getBoundingClientRect().top + (window.scrollY - headerHeight);

    window.addEventListener("scroll", () => {
      if (window.scrollY > stickyTop) {
        sticky.classList.add("is-sticky");
      } else {
        sticky.classList.remove("is-sticky");
      }
    });
  }

  function enableToggleFilterSidebarDesktop(elem = '.facets--horizontal .facets--filters-title') {
    const toggler = document.querySelector(elem);
    const collectionWrapper = document.querySelector(".product-grid-container .collection-wrapper");
    const filterSidebar = document.querySelector('.product-grid-container div.facets-block-wrapper--vertical');
    const toggleButton = document.querySelector(".facets-toggle__button");
    if(!toggler || !collectionWrapper || !filterSidebar || !toggleButton) return;

    document.addEventListener("click", function(e){
      if(!e.target.closest(elem)) return;

      if(window.innerWidth >= 750) {
        if(filterSidebar.classList.contains("hidden")) {
          if(window.innerWidth >= 990) {
            collectionWrapper.style.setProperty("--facets-vertical-col-width", 4);
          } else {
            collectionWrapper.style.setProperty("--facets-vertical-col-width", 5);
          }
          filterSidebar.classList.remove("hidden");
        } else {
          collectionWrapper.style.setProperty("--facets-vertical-col-width", 1);
          filterSidebar.classList.add("hidden");
        }
      } else {
        toggleButton.click();
      }
    });
  }

  function enableFilterRemovePills() {
    document.addEventListener("click", function (e) {
      var pill = e.target.closest('.product-grid-container .collection-wrapper > .facets-remove facet-remove-component');
      if (!pill) pill = e.target.closest(".product-grid-container .collection-wrapper > .facets-remove facet-remove-component .facets__clear-all-link")?.parentElement;
      if (!pill) return; // clicked outside of a pill

      const removePillsWrapper = document.querySelector('.product-grid-container .collection-wrapper > .facets-remove');
      const targetRemovePillsWrapper = document.querySelector(".product-grid-container div.facets-block-wrapper--vertical .facets--vertical .facets-remove");
      if (!removePillsWrapper || !targetRemovePillsWrapper) return;

      const targetRemovePills = targetRemovePillsWrapper.querySelectorAll("facet-remove-component");
      if (!targetRemovePills.length) return;

      const targetUrl = pill.getAttribute("data-url");
      targetRemovePills.forEach((target) => {
        if (target.getAttribute("data-url") === targetUrl) {
          target.click();
          target.querySelector("button")?.click();
        }
      });
    });
  }

  function enableCustomSortingRadios() {
    document.addEventListener("change", function (e) {
      const sortByWrapper = e.target.closest("accordion-custom.facets__sortby");
      const inputs = sortByWrapper?.querySelectorAll("input");

      if(!sortByWrapper || window.innerWidth < 750) return;
      document.querySelector("#filters-drawer accordion-custom.facets__sortby")?.remove();

      var target = '';
      inputs.forEach((input) => {
        input.setAttribute("name", "");
        if(input.checked) {
          target = input.value;
        }
      });

      setTimeout(() => {
        const targetSortItems = document.querySelectorAll(".product-grid-container .facets-controls-wrapper sorting-filter-component floating-panel-component label");
        if(!targetSortItems) return;

        targetSortItems.forEach((item) => {
          if(item.querySelector("input")?.value == target) {
            item.click();
          }
        });
      }, 50);
    });
  }

  function enableCustomSortingRadiosMobile() {
    document.addEventListener("change", function (e) {
      const sortByWrapper = e.target.closest("#filters-drawer")?.querySelector("accordion-custom.facets__sortby");
      const inputs = sortByWrapper?.querySelectorAll("input");

      if(!sortByWrapper || window.innerWidth >= 750) return;
      document.querySelector(".product-grid-container div.facets-block-wrapper--vertical .facets--vertical accordion-custom.facets__sortby")?.remove();

      var target = '';
      inputs.forEach((input) => {
        input.setAttribute("name", "");
        if(input.checked) {
          target = input.value;
        }
      });

      setTimeout(() => {
        const targetSortDropdown = document.querySelector("#filters-drawer sorting-filter-component .sorting-filter__select");
        if(!targetSortDropdown) return;
  
        targetSortDropdown.value = target;
        targetSortDropdown.closest("sorting-filter-component").dispatchEvent(new Event("change"));
      }, 50);
    });
  }

  function changeTestimonialPosition(grid = '.product-grid-container .product-grid', target = '.product-grid-container .product-grid .testimonial-card') {
    const container = document.querySelector(grid);
    const testimonial = document.querySelector(target);
    if (!container || !testimonial) return;

    const moveTestimonial = (newPosition) => {
      const children = Array.from(container.children);
      const currentIndex = children.indexOf(testimonial);
      if (currentIndex === newPosition) return; // already there

      // Temporarily remove from list
      container.removeChild(testimonial);

      // Rebuild children after removal
      const updatedChildren = Array.from(container.children);

      // Adjust index if needed
      if (newPosition >= updatedChildren.length) {
        container.appendChild(testimonial);
      } else {
        container.insertBefore(testimonial, updatedChildren[newPosition - 1]);
      }

      // Update attribute
      testimonial.setAttribute('data-position', newPosition);
    };

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const { width } = entry.contentRect;
        var desktopTargetWidth = !document.querySelector(".product-grid-container div.facets-block-wrapper--vertical").classList.contains("hidden") ? 1525 : 1415;
        var latopTargetWidth = !document.querySelector(".product-grid-container div.facets-block-wrapper--vertical").classList.contains("hidden") ? 1131 : 1132;
        var tabletTargetWidth = !document.querySelector(".product-grid-container div.facets-block-wrapper--vertical").classList.contains("hidden") ? (window.innerWidth >= 750 ? 899 : 707) : (window.innerWidth >= 750 ? 848 : 899);

        if (width <= tabletTargetWidth) {
          const mobilePosition = parseInt(testimonial.dataset.mobilePosition, 10);
          if (!isNaN(mobilePosition)) moveTestimonial(mobilePosition);
        } else if (width <= latopTargetWidth) {
          moveTestimonial(4);
        } else if (width <= desktopTargetWidth) {
          moveTestimonial(8);
        } else {
          moveTestimonial(10);
        }
      }
    });

    resizeObserver.observe(container);
  }

  enableStickyFilter();
  enableToggleFilterSidebarDesktop();
  enableFilterRemovePills();
  enableCustomSortingRadios();
  enableCustomSortingRadiosMobile();
  changeTestimonialPosition();
}

function initIsotopeReviewsMasonry() {
  // 1. Check if we are on a product page
  if (!document.body.classList.contains('template-product') || !document.querySelector('.jdgm-rev-widg__body .jdgm-rev-widg__reviews .jdgm-rev') || window.innerWidth < 750) return;

  // 3. Load Isotope script dynamically
  const isotopeScriptUrl = "https://cdnjs.cloudflare.com/ajax/libs/jquery.isotope/3.0.6/isotope.pkgd.min.js";
  const existingScript = document.querySelector(`script[src="${isotopeScriptUrl}"]`);
  
  const loadIsotope = () => {
    // Wait until jQuery and Isotope are available
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.isotope === 'undefined') {
      setTimeout(loadIsotope, 100);
      return;
    }

    // Initialize Isotope masonry on Judge.me reviews
    const $ = jQuery;
    const $grid = $('.jdgm-rev-widg__reviews');
    var columnWidth = parseInt($('.jdgm-rev-widg__reviews').width() / 3);
    if ($grid.length) {
      setTimeout(() => {
        $grid.isotope({
          itemSelector: '.jdgm-rev',
          layoutMode: 'masonry',
          percentPosition: true,
          masonry: {
            columnWidth: columnWidth,
            gutter: 10
          }
        });
      }, 500);
    }
  };

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = isotopeScriptUrl;
    script.integrity = "sha512-Zq2BOxyhvnRFXu0+WE6ojpZLOU2jdnqbrM1hmVdGzyeCa1DgM3X5Q4A/Is9xA1IkbUeDd7755dNNI/PzSf2Pew==";
    script.crossOrigin = "anonymous";
    script.referrerPolicy = "no-referrer";
    script.onload = loadIsotope;
    document.head.appendChild(script);
  } else {
    loadIsotope();
  }
}